// Explicit synthetic preview data. Never used as component defaults.

export const FIXTURE_OPERATOR = {
  email: 'ops@chorestory.com',
  sessionLabel: 'platform session · expires 14:00Z',
  initials: 'OP',
  accent: 'blue',
};

export const FIXTURE_STATS = [
  { id: 'tenants', label: 'Tenants', value: 547, delta: '+12', deltaDirection: 'up', detail: 'this week' },
  { id: 'active', label: 'Active 7d', value: 412, detail: '75.3% of tenants' },
  { id: 'quests', label: 'Quests 7d', value: 9381, delta: '+4.1%', deltaDirection: 'up', detail: 'wk/wk' },
  { id: 'jobs', label: 'Jobs queued', value: 3, tone: 'warn', detail: 'oldest 41s · mv_refresh' },
];

export const FIXTURE_TENANTS = [
  {
    id: 'silva-family',
    name: 'Silva Family',
    slug: 'silva-family',
    plan: 'beta',
    planTone: 'gold',
    members: 5,
    lastActive: '2 min ago',
    status: 'active',
    statusTone: 'moss',
    detail: {
      impersonation: false,
      fields: [
        { id: 'created', label: 'Created', value: '2025-11-03' },
        { id: 'tz', label: 'Timezone', value: 'America/Toronto' },
        { id: 'mv', label: 'MV refresh', value: '2026-06-12 01:00:00Z' },
        { id: 'payday', label: 'Payday', value: 'Friday · approval on' },
      ],
      actions: [
        { id: 'view-users', label: 'View users', variant: 'secondary' },
        { id: 'suspend', label: 'Suspend tenant', variant: 'danger', danger: true },
      ],
    },
  },
  { id: 'okafor-family', name: 'Okafor Crew', slug: 'okafor-family', plan: 'beta', planTone: 'gold', members: 4, lastActive: '18 min ago', status: 'active', statusTone: 'moss' },
  { id: 'nguyen-family', name: 'Nguyen Household', slug: 'nguyen-family', plan: 'beta', planTone: 'gold', members: 6, lastActive: '1 h ago', status: 'active', statusTone: 'moss' },
  { id: 'sunshine-family', name: 'Sunshine Family', slug: 'sunshine-family', plan: 'beta', planTone: 'gold', members: 3, lastActive: '9 d ago', status: 'suspended', statusTone: 'rose' },
  { id: 'rossi-casa', name: 'Rossi Casa', slug: 'rossi-casa', plan: 'beta', planTone: 'gold', members: 7, lastActive: '3 h ago', status: 'active', statusTone: 'moss' },
  { id: 'achebe-house', name: 'Achebe House', slug: 'achebe-house', plan: 'beta', planTone: 'gold', members: 2, lastActive: 'yesterday', status: 'active', statusTone: 'moss' },
];

export const FIXTURE_USERS = [
  { id: 'sara', name: 'Sara Silva', email: 'sara@silva.family', initials: 'SS', tone: 'default', role: 'admin', tenants: ['silva-family'] },
  { id: 'david', name: 'David Silva', email: 'david@silva.family', initials: 'DS', tone: 'gold', role: 'admin', tenants: ['silva-family'] },
  { id: 'rosa', name: 'Rosa Silva', email: 'rosa.silva@mail.com', initials: 'RS', tone: 'violet', role: 'member', tenants: ['silva-family', 'rossi-casa'] },
];

export const FIXTURE_AUDIT = [
  { id: 'a1', ts: '2026-06-12 01:12:09Z', actor: 'ops@chorestory.com', action: 'TENANT_SUSPEND', target: 'sunshine-family', ip: '203.0.113.7', category: 'tenants' },
  { id: 'a2', ts: '2026-06-12 01:11:42Z', actor: 'ops@chorestory.com', action: 'CONSENT_EXPORT', target: 'silva-family/sara', ip: '203.0.113.7', category: 'data' },
  { id: 'a3', ts: '2026-06-12 01:00:00Z', actor: 'system', action: 'MV_REFRESH', target: 'mv_weekly_earnings', ip: '—', category: 'data' },
  { id: 'a4', ts: '2026-06-12 00:58:31Z', actor: 'ops@chorestory.com', action: 'TOKEN_REVOKE', target: 'display:kitchen-7f3a', ip: '203.0.113.7', category: 'auth' },
  { id: 'a5', ts: '2026-06-12 00:47:18Z', actor: 'admin@chorestory.com', action: 'LOGIN', target: 'platform-console', ip: '198.51.100.23', category: 'auth' },
  { id: 'a6', ts: '2026-06-11 23:30:05Z', actor: 'system', action: 'MV_REFRESH', target: 'mv_village_stats', ip: '—', category: 'data' },
  { id: 'a7', ts: '2026-06-11 22:18:54Z', actor: 'ops@chorestory.com', action: 'TENANT_CREATE', target: 'okafor-family', ip: '203.0.113.7', category: 'tenants' },
  { id: 'a8', ts: '2026-06-11 21:42:11Z', actor: 'admin@chorestory.com', action: 'CONSENT_EXPORT', target: 'nguyen-family/an', ip: '198.51.100.23', category: 'data' },
  { id: 'a9', ts: '2026-06-11 20:05:51Z', actor: 'ops@chorestory.com', action: 'LOGIN', target: 'platform-console', ip: '203.0.113.7', category: 'auth' },
  { id: 'a10', ts: '2026-06-11 20:05:37Z', actor: 'ops@chorestory.com', action: 'LOGIN_FAIL', target: 'platform-console', ip: '203.0.113.99', category: 'auth', failed: true },
];

export const FIXTURE_HEALTH = {
  version: 'chorestory v2026.6.2 · build 8841',
  region: 'region ca-central-1',
  latency: 'p95 api 142ms',
  statusLabel: 'all systems calm',
  ok: true,
};

export const platformAdminFixture = {
  operator: FIXTURE_OPERATOR,
  stats: FIXTURE_STATS,
  tenants: FIXTURE_TENANTS,
  users: FIXTURE_USERS,
  audit: FIXTURE_AUDIT,
  health: FIXTURE_HEALTH,
  environment: 'production',
  consoleHost: 'admin.chorestory.com',
  region: 'ca-central-1',
  totalTenants: 547,
  totalUsers: 2114,
  defaultUserQuery: 'silva',
};
